<template>
  <b-container>
    <div class="teams">
      <h1>Teams</h1>
      <div v-if="teams && teams.length > 0" class="table-wrap">
        <div>
          <router-link v-if="isAdmin" :to="{ name: 'NewTeam' }" class
            >+Add Team</router-link
          >
        </div>
        <br />
        <b-row>
          <b-col>
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Type to Filter Teams"
              />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col md="6">
            <b-form-group horizontal label="Sort">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions">
                  <option slot="first" :value="null">-- none --</option>
                </b-form-select>
                <b-form-select
                  :disabled="!sortBy"
                  v-model="sortDesc"
                  slot="append"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-table
          v-cloak
          responsive
          :fields="fields"
          :items="teams"
          :striped="true"
          :bordered="true"
          :hover="true"
          stacked="md"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
        >
          <template slot="cell(team_name)" slot-scope="row">
            <b-link
              @click.stop="stopClick"
              :to="{ name: 'EditTeam', params: { id: row.item.uuid } }"
              >{{ row.value }}</b-link
            >
          </template>
          <template slot="cell(active)" slot-scope="row">
            <b-form-radio-group
              :id="row.index.toString()"
              :value="row.item.active"
              v-model="row.item.active"
              @change="updateTeam(row.item)"
            >
              <b-form-radio :value="true">True</b-form-radio>
              <b-form-radio :value="false">False</b-form-radio>
            </b-form-radio-group>
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="teams.length || 0"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </b-col>
          <download-button :export="teams" :file="file"></download-button>
        </b-row>
      </div>
      <div v-else>
        Teams are loading...
        <br />
        <br />
        <router-link v-bind:to="{ name: 'NewTeam' }" class="add_school_link"
          >+Add Team</router-link
        >
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DownloadButton from "@/components/DownloadButton";
import TeamService from "@/services/TeamService";

export default {
  name: "TeamsList",
  components: {
    DownloadButton,
  },
  data() {
    return {
      file: this.$route.path.slice(1),
      fields: [
        { key: "team_name", label: "Team Name" },
        { key: "description", label: "Description", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "region", label: "Region", sortable: true },
        { key: "district", label: "District", sortable: true },
        { key: "active", label: "Active", sortable: true },
      ],
      currentPage: 0,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
    };
  },
  methods: {
    ...mapActions({
      GET_TEAMS: "teams/GET_TEAMS",
      RESET_TEAMS_STATE: "teams/RESET_TEAMS_STATE",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    stopClick(row) {},
    async updateTeam(params) {
      const payload = await {
        id: params.id,
        active: !params.active,
      };
      await TeamService.updateTeamActive(payload);
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
    }),
    teams: {
      get() {
        return this.$store.state.teams.teams;
      },
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  watch: {
    currentPage: {
      handler(val) {
        //console.log("watch: ", val);
        TeamService.fetchTeams(val, this.perPage).catch((err) =>
          console.error(err)
        );
      },
    },
  },
  created() {
    this.GET_TEAMS();
  },
};
</script>

<style scoped>
#teams {
  table-layout: fixed;
  width: 100%;
}
.name {
  width: 20%;
  white-space: nowrap;
}
.sex {
  width: 7.5%;
}
.designation {
  width: 10%;
}
.edit {
  width: 7.5%;
}

.table-wrap {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
table th,
table tr {
  text-align: center;
}
table thead {
  background: #bf9660;
}
td {
  width: 100px;
  text-align: center;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #bf9660;
  color: #fff;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
a.add_trainer_link {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
}
</style>
